<template>
  <div class="4 prime-table-large-font border border-gray-200 rounded-lg ">
    <DataTable
      :value="data"
      :dataKey="dataKey"
      :selection="localSelection"
      @update:selection="val => localSelection = val"
      :tableStyle="tableStyle"
      :paginator="paginator"
      :rows="rows"
      :totalRecords="totalRecords"
      :first="first"
      :lazy="lazy"
      :rowsPerPageOptions="rowsPerPageOptions"
      :loading="props.loading"
      @page="$emit('page', $event)"
      scrollable
      scrollHeight="flex"
    >

      <template #empty>
        <div class="text-center text-gray-500 py-8">
          {{ emptyMessage || 'No data available' }}
        </div>
      </template>
      <Column
        v-if="showCheckbox"
        selectionMode="multiple"
        headerStyle="width: 3rem"
         :showSelectAll="false"
      />
      <Column
        v-for="header in headers"
        :key="header.field"
        :field="header.field"
        :header="header.header"
        :body="header.body"
        :style="header.style"
      >
        <template #body="slotProps">
          <template v-if="header.type === 'actions'">
            <slot name="actions" :row="slotProps.data" />
          </template>
          <template v-else>
            <slot :name="header.field" :row="slotProps.data">
              {{ slotProps.data[header.field] }}
            </slot>
          </template>
        </template>
      </Column>

      <slot />
    </DataTable>
  </div>
</template>

<script setup lang="ts">

interface Header {
  field: string;
  header: string;
  body?: (...args: unknown[]) => unknown;
  style?: string | object;
  type?: string;
}

const props = defineProps<{
  headers: Header[];
  data: Record<string, unknown>[];
  showCheckbox?: boolean;
  selection?: Record<string, unknown> | Record<string, unknown>[];
  dataKey?: string;
  tableStyle?: string | object;
  selectionMode?: string;
 emptyMessage?: string;
 paginator?: boolean;
  rows?: number;
  totalRecords?: number;
  first?: number;
  rowsPerPageOptions?: number[];
  lazy?: boolean;
  loading?: boolean;
}>();

const emit = defineEmits(['update:selection', 'page']);

const showCheckbox = computed(() => props.showCheckbox ?? false);
const dataKey = computed(() => props.dataKey ?? 'id');
const tableStyle = computed(() => props.tableStyle ?? 'min-width: 50rem');

// Local selection state
const localSelection = ref(props.selection);

// Watch for prop changes from parent
watch(
  () => props.selection,
  (val) => {
    localSelection.value = val;
  },
);

// Emit update when local selection changes
watch(
  localSelection,
  (val) => {
    emit('update:selection', val);
  },
);
</script>

<style scoped>
.prime-table-large-font {
  font-size: 0.9rem;
}
</style>
